// @catalog F.047 F.048
// Pantalla /mercado-libre/resultados: resultado de las importaciones con una
// pestaña por plataforma — Mercado Libre (pedidos con economía real y
// matching Odoo), Amazon y Walmart (líneas de la ingesta pura; sin economía
// del canal — sus exports no traen comisiones). El resumen mensual vive en
// su propia pantalla /mercado-libre/resumen. Cabecera compacta: título y
// pestañas en una sola línea (petición del propietario 2026-08-21 — el alto
// es espacio operativo).
import { useState } from "react";
import { Box, Tab, Tabs, useMediaQuery, useTheme } from "@mui/material";
import { PageHead } from "../components/analytics/PageHead";
import { PedidosBlock } from "../components/MercadoLibre/PedidosBlock";
import { AmazonPedidosBlock } from "../components/MercadoLibre/AmazonPedidosBlock";
import { WalmartPedidosBlock } from "../components/MercadoLibre/WalmartPedidosBlock";

type PlatformTab = "mercado_libre" | "amazon" | "walmart";

export function EcommerceResultadosPage(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [tab, setTab] = useState<PlatformTab>("mercado_libre");

  return (
    <Box sx={{ p: isMobile ? 2 : 3, pt: isMobile ? 1.5 : 2 }}>
      <PageHead
        title="Resultados ecommerce"
        actions={
          <Tabs
            value={tab}
            onChange={(_e, v: PlatformTab) => setTab(v)}
            sx={{
              minHeight: 38,
              "& .MuiTab-root": { minHeight: 38, py: 0.5 },
            }}
          >
            <Tab label="Mercado Libre" value="mercado_libre" />
            <Tab label="Amazon" value="amazon" />
            <Tab label="Walmart" value="walmart" />
          </Tabs>
        }
      />
      {tab === "mercado_libre" && <PedidosBlock />}
      {tab === "amazon" && <AmazonPedidosBlock />}
      {tab === "walmart" && <WalmartPedidosBlock />}
    </Box>
  );
}
